module.exports = __webpack_public_path__ + "assets/img/demoAccess/subjects/9/details-small.png";